import React, { Component } from 'react'
import { Config } from '../Config';

class ListaItens extends Component {
    constructor(props) {
        super(props)
        this.state = {
            classes: 'page-concursos__cargos-list'
        }
    }

    componentDidMount() {
        //console.log(this.props.fullWidth)
        if (this.props.fullWidth) {
            this.setState({ classes: `${this.state.classes} page-concursos__cargos-list--full-list-width` })
        }
    }

    renderLink(x) {
        if (x.isGuid) {
            return (<a href={`${Config.cdnLink}${x.nomeArquivo}`} target="_blank">{x.descricaoArquivo}</a>);
        } else {

            if (x.tipoExtensaoArquivo === "_explorer") {
                if (this.props.tipoEvento === "vestibulares") {
                    return (<a href={`http://www.cespe.unb.br/vestibular/${this.props.identificador}/arquivos/${x.nomeArquivo}`} target="_blank">{x.descricaoArquivo}</a>);
                }
                else {
                    return (<a href={`http://www.cespe.unb.br/${this.props.tipoEvento}/${this.props.identificador}/arquivos/${x.nomeArquivo}`} target="_blank">{x.descricaoArquivo}</a>);
                }
            }
            else {
                if (this.props.tipoEvento === "vestibulares") {
                    return (<a href={`${Config.cdnLink}vestibulares/${this.props.identificador}/arquivos/${x.nomeArquivo}`} target="_blank">{x.descricaoArquivo}</a>);
                } else {
                    return (<a href={`${Config.cdnLink}${this.props.tipoEvento}/${this.props.identificador}/arquivos/${x.nomeArquivo}`} target="_blank">{x.descricaoArquivo}</a>);
                }
            }
        }
    }

    render() {
        return (
            <div>
                <ul className={this.state.classes}>
                    {
                        this.props.itens &&
                        this.props.itens.map((x, i) => {
                            return (
                                <li key={i}>
                                    <div>
                                        <h2>{x.dataArquivo}</h2>
                                        <hr />
                                        <p>{this.renderLink(x)}</p>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        )
    }
}

export default ListaItens